export default __webpack_public_path__ + "static/st-marouns-crest-2020-with-text-2f04d6a223c630d14ff6f420ecbcc3db.png";